export const state = {
  userToken: null,
  userData: null,
};

export const getters = {
  userToken(state) {
    return state.userToken;
  },
  userData(state) {
    return state.userData;
  },
  loggedIn(state) {
    return !!state.userToken;
  },
};

export const mutations = {
  SET_USER_TOKEN(state, newValue) {
    state.userToken = newValue;
  },
  SET_USER_ROLE(state, newValue) {
    state.userData = newValue;
  },
};

export const actions = {
  setUserToken({ commit }, token = null) {
    commit('SET_USER_TOKEN', token);
  },
  setUserData({ commit }, role = null) {
    commit('SET_USER_ROLE', role);
  },
};
